<template>
    <div id="app">
        <top_nav class="top_nav" v-show="showTop" :class="{topActive:isScroll}"></top_nav>
        <div class='container'>
            <router-view/>
            <!-- 右侧悬浮 -->
            <!--<div class="laykefu-min " id="show-laykefu">咨询客服</div>-->
            <!-- 右侧悬浮 -->
            <div class="ewmk">
                <!--<div class="QQ">-->
                <!--<a v-show="showQQ" target="_blank"-->
                <!--:href="'https://wpa.qq.com/msgrd?v=3&uin=' + QQ + '&site=qq&menu=yes'">-->
                <!--<img class="images" src="../assets/images/qq.png" alt="">-->
                <!--</a>-->
                <!--</div>-->
                <div @click="backTop()" class="back" title="返回顶部" v-show="upload">
                    <img src="../assets/images/toTop.png" alt="">
                </div>
            </div>
        </div>
        <v-footer v-show="showFooter"></v-footer>

    </div>
</template>
<script type="text/ecmascript-6">
	import top_nav from '../components/nav.vue'
	import vfooter from '../components/Footer.vue'

	export default {
		name: '',
		data() {
			return {
				isScroll: false,
				showTop: true,
				showFooter: true,
				erWeiMa: '',
				QQ: '',
				upload: false,
				showEWM: false,
				fullWidth: document.documentElement.clientWidth,
				// showQQ: false
			}
		},
		created() {
			// this.$notify({
			// 	title: '提示',
			// 	message: '当前为测试版本！',
			// 	type: 'warning',
			// });
			window.addEventListener('resize', this.handleResize)
			const that = this
			// console.log(localStorage.getItem('userInfo'))
			if (localStorage.getItem('userInfo') != null) {
				// console.log(JSON.parse(localStorage.getItem('userInfo')))
				that.userInfo = JSON.parse(localStorage.getItem('userInfo'))
				document.cookie = 'welive_id=' + that.userInfo.id
				document.cookie = 'welive_fn=' + that.userInfo.name
			}
			window.addEventListener('setItemEvent', function (e) {
				// console.log(e)
				if (e.key === 'userInfo') {
					that.userInfo = JSON.parse(e.newValue)
					document.cookie = 'welive_id=' + that.userInfo.id
					document.cookie = 'welive_fn=' + that.userInfo.name
				}
			})
		},

		computed: {},
		mounted() {
			this.init()
			window.addEventListener('scroll', this.handleScroll);
		},
		methods: {
			init() {
				console.log(localStorage.getItem('QQ'))
				this.erweima = localStorage.getItem('erweima')
				// this.QQ = localStorage.getItem('QQ')
				// if (this.QQ === '') {
				// 	this.showQQ = false
				// } else {
				// 	this.showQQ = true
				// }
			},
			handleResize() {
				this.fullWidth = document.documentElement.clientWidth
				if (1200 < this.fullWidth && this.fullWidth < 1217) {
					this.$message.error('屏幕宽度太小')
				}
			},
			// // 微信客服二维码显示隐藏
			// toShow() {
			// 	this.showEWM = !this.showEWM
			// },

			//返回顶部
			backTop() {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},
			// 滚动监测
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// console.log(scrollTop)
				if (scrollTop > 540) {
					this.isScroll = true
					this.upload = true
					document.getElementById('welive_online').style.bottom = '120px'
				} else {
					this.isScroll = false
					this.upload = false
					document.getElementById('welive_online').style.bottom = '50px'
				}
			},
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		beforeDestroy: function () {
			window.removeEventListener('resize', this.handleResize)
		},
		watch: {
			$route(route) {
				// console.log(route)
				const path = route.path.split('/')[1]
				// if (path === 'auctionDetail' || path === 'personal' || path === 'expert' || path === 'aboutUs') {
				// 	this.showTop = false
				// } else {
				// 	this.showTop = true
				// }
				if (path === 'login' || path === 'resetPwd' || path === 'resetsuccess') {
					this.showFooter = false
				} else {
					this.showFooter = true
				}
				// if (path !== 'aboutUs') {
				// 	this.$addStorageEvent('aboutIndex', '')
				// }
			},

		},
		components: {'v-footer': vfooter, top_nav}
	}
</script>

<style lang="less">
    @import "../assets/css/reset";
    @import "app/app.less";
</style>
